import {Component, effect, viewChild} from '@angular/core';
import {RouterOutlet} from '@angular/router';
import {MessageToastComponent} from './components/message-toast/message-toast.component';

@Component({
    selector: 'app-root',
    imports: [
        RouterOutlet,
        MessageToastComponent
    ],
    templateUrl: './app.component.html',
    styleUrl: './app.component.scss'
})
export class AppComponent {
    title = 'portfolio-mgmt-ui';

    private messageToastComponent = viewChild(MessageToastComponent);
    static messageToast: MessageToastComponent;

    constructor() {
        effect(() => AppComponent.messageToast = this.messageToastComponent()!);
    }
}
